// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__SDEdW","footer":"NavbarSimple_footer__6mdeo","link":"NavbarSimple_link__VYV3w","linkIcon":"NavbarSimple_linkIcon__XrP6l"};